import styled from 'styled-components';
import { borderRadius, colorUsage, getSpacing } from 'stylesheet';

export const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 ${getSpacing(26)};
  background-color: ${colorUsage.contentBackground};
`;
RootContainer.displayName = 'RootContainer';

export const PageContent = styled.main`
  border-radius: ${borderRadius.large};
  padding: ${getSpacing(6)};
  flex-grow: 1;
`;
PageContent.displayName = 'PageContent';
